import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import type { ChartScaleMode } from "./chartScale";

type ChartScaleNoticeProps = {
  clipped: boolean;
  canLogarithmicScale: boolean;
  scaleMode: ChartScaleMode;
  onScaleModeChange: (mode: ChartScaleMode) => void;
};

export const ChartScaleNotice = ({
  clipped,
  canLogarithmicScale,
  scaleMode,
  onScaleModeChange,
}: ChartScaleNoticeProps) => {
  if (!clipped && scaleMode === "fixed") return null;

  if (scaleMode === "fixed") {
    return (
      <Alert
        severity="warning"
        sx={{ mb: 1, py: 0, alignItems: "center", "& .MuiAlert-message": { py: 0.75 } }}
        action={
          <>
            <Button size="small" onClick={() => onScaleModeChange("linear-auto")}>Ver todo</Button>
            {canLogarithmicScale && (
              <Button size="small" onClick={() => onScaleModeChange("logarithmic")}>Usar log</Button>
            )}
          </>
        }
      >
        Hay valores fuera del rango lineal configurado y pueden quedar ocultos.
      </Alert>
    );
  }

  return (
    <Alert
      severity="info"
      sx={{ mb: 1, py: 0, alignItems: "center", "& .MuiAlert-message": { py: 0.75 } }}
      action={
        <Button size="small" onClick={() => onScaleModeChange("fixed")}>
          Restaurar rango
        </Button>
      }
    >
      {scaleMode === "logarithmic" ? "Escala logarítmica activa." : "Escala lineal automática activa."}
    </Alert>
  );
};
